import { Button } from '@vnetwork/ui/primitives';
import { brandCopyright } from '@/config/brand';
import { useAuth } from '@/auth/AuthProvider';
import { AuthShell } from './components/AuthShell';
import styles from './AccessRemovedPage.module.css';

/**
 * Full-viewport gate shown when the session is valid but the account no longer
 * maps to a live org contact (the member was removed). Rendered by ProtectedRoute
 * in place of the console, so NO customer-scoped requests fire. Reuses AuthShell
 * so the logo, card, and typography match the sign-in pages exactly.
 */
export default function AccessRemovedPage() {
  const { user, logout } = useAuth();

  return (
    <AuthShell
      title="Access removed"
      subtitle={
        <>
          Your account{user?.email ? ` (${user.email})` : ''} is no longer a member of an
          organization, so the console is unavailable.
        </>
      }
      footer={brandCopyright()}
    >
      <div className={styles.stack}>
        <p className={styles.note}>
          If you believe this is a mistake, contact your organization owner to be re-invited.
        </p>
        <Button variant="secondary" className={styles.signout} onClick={() => logout()}>
          Sign out
        </Button>
      </div>
    </AuthShell>
  );
}
